import PayModal from 'attendee/Billing/PayModal'
import React from 'react'

export default function Modals(props: {modals?: React.ReactElement}) {
  return (
    <>
      <PayModal />
      {props.modals}
    </>
  )
}
